import { render } from "./DotsSvg.vue?vue&type=template&id=512a0b16&scoped=true"
const script = {}

import "./DotsSvg.vue?vue&type=style&index=0&id=512a0b16&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512a0b16"]])

export default __exports__